import styled from 'styled-components';
import { Flex, MotionBox } from '..';
export var containerAnimation = {
  enter: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
      duration: 0.25
    }
  },
  exit: {
    opacity: 0,
    transition: {
      delay: 0.25,
      duration: 0.25
    }
  }
};
export var ModalContainer = styled(MotionBox).attrs({
  variants: containerAnimation,
  initial: 'exit',
  animate: 'enter',
  exit: 'exit',
  py: 'xxxl'
}).withConfig({
  displayName: "styled__ModalContainer",
  componentId: "sc-148di7t-0"
})(["position:fixed;z-index:1000;top:0;right:0;bottom:0;left:0;overflow:auto;"]);
export var dialogAnimation = {
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    y: 100,
    opacity: 0,
    transition: {
      duration: 0.25
    }
  }
};
export var ModalDialogWrapper = styled(MotionBox).attrs({
  variants: dialogAnimation
}).withConfig({
  displayName: "styled__ModalDialogWrapper",
  componentId: "sc-148di7t-1"
})(["display:flex;max-height:100%;justify-content:center;"]);
export var ModalBackdrop = styled.div.withConfig({
  displayName: "styled__ModalBackdrop",
  componentId: "sc-148di7t-2"
})(["position:absolute;z-index:0;top:0;right:0;bottom:0;left:0;background:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.base.black + "65";
});
export var ModalDialogContent = styled(Flex).attrs(function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;
  return {
    width: theme.modal.sizes[size].width
  };
}).withConfig({
  displayName: "styled__ModalDialogContent",
  componentId: "sc-148di7t-3"
})(["z-index:1;"]);